/**
 * last_active_atからアクター状態を計算
 * @param {string|Date} lastActiveAt - 最終アクティブ日時
 * @returns {string} 'active' | 'away_1h' | 'away_12h' | 'inactive'
 */
export const getActorStatusFromLastActive = (lastActiveAt) => {
  if (!lastActiveAt) return 'inactive';
  
  const now = new Date();
  const lastActive = new Date(lastActiveAt);
  const hoursDiff = (now - lastActive) / (1000 * 60 * 60);
  
  if (hoursDiff < 1) return 'active';        // 1時間以内 → 緑●
  if (hoursDiff < 12) return 'away_1h';      // 12時間以内 → 黄●
  return 'away_12h';                          // 12時間以上 → 橙●
};
